import Divider from '@mui/material/Divider';

import { useTranslate } from 'src/locales';

// ----------------------------------------------------------------------

export function FormDivider({ label = 'or you can also use', sx }) {
  const { t } = useTranslate();

  return (
    <Divider
      sx={[
        {
          color: 'text.secondary',
          fontSize: { xs: 16, md: 14 },
          '&::before, :after': { borderTopStyle: 'dashed' },
        },
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    >
      {t(label)}
    </Divider>
  );
}
